import React from "react";
import useCtaContainer from "../../../../hooks/shared/actions/useCtaList";
import * as Styles from "../../../../../../../common-deprecated/styles/v2/lexus/custom/CustomizeCtaContainer";
import CtaButton from "./CtaButton";

const CustomizeCtaContainer = (): JSX.Element | null => {
    const ctas = useCtaContainer("customizeHeroCta");

    const [firstCta, secondCta] = ctas;
    if (!firstCta && !secondCta) return null;

    return (
        <Styles.Wrapper>
            {firstCta && firstCta.title && (
                <CtaButton linkType="primary" config={firstCta}>
                    {firstCta.title}
                </CtaButton>
            )}
            {secondCta && secondCta.title && (
                <CtaButton linkType="negative" config={secondCta}>
                    {secondCta.title}
                </CtaButton>
            )}
        </Styles.Wrapper>
    );
};

export default CustomizeCtaContainer;
